<template>
    <div class='outer'>

      <p class="til top">扫一扫 添加官方客服微信</p>
      <img class="qr" src="../../assets/img/contact-qr-code.jpg" alt>
      <p class="sub">全国客服专用</p>

      <img class="qr" src="../../assets/img/contact_us/shandongserve.png" alt>
      <p class="sub">山东大区客服专用</p>

      <p class="til">扫一扫 关注官方服务号</p>
      <img class="qr" src="../../assets/img/contact_us/serveaccount.png" alt>

      <div class="call">
        <img class="ic" src="../../assets/img/contact_us/ic_call.png" alt>
        <p>客服电话 <span class="phone" @click="callNumber('19902907765')"> 19902907765</span></p>
      </div>


    </div>
</template>

<script>
    export default {
        name: "Contact"
    }
</script>

<style lang="scss" scoped>
.outer{
  position: absolute;
  width: calc(100vw - .4rem);
  height: calc(100vh - .4rem);
  margin: .2rem;
  p{
    text-align: center;
    &.til{
      font-size: .4rem;
      margin: .8rem .5rem .3rem .5rem;
      font-weight: bold;
      &.top{
        margin-top: .3rem;
      }
    }
    &.sub{
      letter-spacing: .01rem;
      font-size: .25rem;
      margin: .1rem .5rem .5rem .5rem;
    }
  }

  span{
    display: inline-block;
    color: #00d6c5;
    font-weight: normal;
  }
  .qr{
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: 2.5rem;
  }
  .call{
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: max-content;
    font-size: .4rem;
    margin: 1rem 0;
    display: flex;
    height: max-content;
    p{
      display: inline-block;
      line-height: .56rem;
    }
    .ic{
      display: inline-block;
      width: .55rem;
      height: .56rem;
      margin: 0 .3rem;
    }
  }
}
</style>
